/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Destination_LabelInputs */

const en_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup Destination`)
};

const fr_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination de sauvegarde`)
};

const de_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup-Ziel`)
};

const it_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destinazione di backup`)
};

const ru_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Место назначения резервной копии`)
};

const es_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destino de la copia de seguridad`)
};

const zh_cn2_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备份目标`)
};

const ja_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バックアップ先`)
};

const hi_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैकअप गंतव्य`)
};

const pt_pt2_options_backup_destination_label = /** @type {(inputs: Options_Backup_Destination_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destino de backup`)
};

/**
* | output |
* | --- |
* | "Backup Destination" |
*
* @param {Options_Backup_Destination_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_destination_label = /** @type {((inputs?: Options_Backup_Destination_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Destination_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_destination_label(inputs)
	if (locale === "de") return de_options_backup_destination_label(inputs)
	if (locale === "it") return it_options_backup_destination_label(inputs)
	if (locale === "ru") return ru_options_backup_destination_label(inputs)
	if (locale === "es") return es_options_backup_destination_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_destination_label(inputs)
	if (locale === "ja") return ja_options_backup_destination_label(inputs)
	if (locale === "hi") return hi_options_backup_destination_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_destination_label(inputs)
	return en_options_backup_destination_label(inputs)
});